import React from "react";

import { Box, Tab, Tabs } from "@material-ui/core";
import { startCase } from "lodash";

import Content from "@ds-developer/content";
import PageHeader from "@ds-developer/page-header";

import {
  InstructorInvoices,
  InstructorTransactions,
} from "@hubcapp/components";
import { useAuth, useTealium } from "@hubcapp/context";

import { AccountProps } from "./types";
import { pageHeaderPropsMap } from "./utils";
import FeatureNotAvailable from "../FeatureNotAvailable";

const Accounts: React.FC<AccountProps> = ({
  instructorId,
  selectedTab = "transactions",
  onSelectTab = () => {},
}) => {
  const { instructor } = useAuth();
  if (instructor.status !== "Active") {
    return <FeatureNotAvailable />;
  }
  const { trackEvent } = useTealium();

  const handleChange = (_: unknown, newValue: string) => {
    onSelectTab(newValue);
    trackEvent({
      eventCategory: "Accounts",
      eventAction: "Interaction",
      eventLabel: startCase(newValue),
    });
  };

  return (
    <Content>
      <PageHeader {...pageHeaderPropsMap[selectedTab]} />
      <Tabs
        value={selectedTab}
        indicatorColor="primary"
        textColor="primary"
        onChange={handleChange}
        aria-label="Account tabs"
      >
        <Tab
          label="Transactions"
          value="transactions"
          data-test="view-account-transactions-tab"
          aria-label="Account transactions tab"
        />
        <Tab
          label="Invoices"
          value="invoices"
          data-test="view-account-invoices-tab"
          aria-label="Account invoices tab"
        />
      </Tabs>

      <Box paddingTop={3}>
        {selectedTab === "transactions" && (
          <InstructorTransactions instructorId={instructorId} />
        )}
        {selectedTab === "invoices" && (
          <InstructorInvoices instructorId={instructorId} />
        )}
      </Box>
    </Content>
  );
};
export default Accounts;
